import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { Regions } from '@/constants';
import { updateRegion, useAppDispatch } from '@/store';

export const useUrlRegion = () => {
  const dispatch = useAppDispatch();
  const { search, pathname } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const searchParams = new URLSearchParams(search);
    const region = searchParams
      .get('region')
      ?.toLocaleUpperCase() as keyof typeof Regions;

    if (Regions[region]) {
      dispatch(updateRegion({ region }));

      // Remove 'region' from search params to avoid confusion
      searchParams.delete('region');
      navigate(
        {
          pathname,
          search: searchParams.toString(),
        },
        { replace: true },
      );
    }
  }, [search, pathname, dispatch, navigate]);
};
